import WebModule from '../web_module'

export default class Container extends WebModule

  @selector: '.modulor_web_module_container'

# do not register since this is just superclass
